<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { adminMe, clearAuth, getAdmin, type AdminInfo } from '../api';
import Users from './Users.vue';
import Admins from './Admins.vue';
import AuditLogs from './AuditLogs.vue';
import Posts from './Posts.vue';
import AdSlots from './AdSlots.vue';
import ChannelPosts from './ChannelPosts.vue';
import Stats from './Stats.vue';

const router = useRouter();
const admin = ref<AdminInfo | null>(getAdmin());
const tab = ref('users');

onMounted(async () => {
  try {
    admin.value = await adminMe();
    if (admin.value.role !== 'PLATFORM_ADMIN') {
      ElMessage.error('此后台仅供总后台管理员使用');
      clearAuth();
      router.replace('/login');
    }
  } catch (e) {
    const err = e as { httpStatus?: number };
    if (err.httpStatus === 401) {
      router.replace('/login');
    }
  }
});

function onLogout() {
  clearAuth();
  router.replace('/login');
}
</script>

<template>
  <el-container style="min-height: 100vh;">
    <el-header class="header">
      <div class="title">MBA圈 · 总后台</div>
      <div class="right" v-if="admin">
        <span class="muted">{{ admin.displayName || admin.username }}</span>
        <el-tag size="small" type="danger" style="margin-left: 8px">{{ admin.role }}</el-tag>
        <el-button size="small" link type="danger" @click="onLogout" style="margin-left: 12px">
          退出
        </el-button>
      </div>
    </el-header>
    <el-main class="main">
      <el-tabs v-model="tab">
        <el-tab-pane label="用户管理" name="users">
          <Users v-if="tab === 'users'" />
        </el-tab-pane>
        <el-tab-pane label="广场管理" name="posts">
          <Posts v-if="tab === 'posts'" />
        </el-tab-pane>
        <el-tab-pane label="广告位管理" name="ads">
          <AdSlots v-if="tab === 'ads'" />
        </el-tab-pane>
        <el-tab-pane label="头条/训练营" name="channels">
          <ChannelPosts v-if="tab === 'channels'" />
        </el-tab-pane>
        <el-tab-pane label="审核员管理" name="admins">
          <Admins v-if="tab === 'admins'" />
        </el-tab-pane>
        <el-tab-pane label="审核日志" name="audit-logs">
          <AuditLogs v-if="tab === 'audit-logs'" />
        </el-tab-pane>
        <el-tab-pane label="服务费配置" name="fees" disabled>
          <el-alert type="info" :closable="false">P3/P4 期启用</el-alert>
        </el-tab-pane>
        <el-tab-pane label="财务总览" name="finance" disabled>
          <el-alert type="info" :closable="false">P3 期启用</el-alert>
        </el-tab-pane>
        <el-tab-pane label="数据看板" name="stats" lazy>
          <Stats v-if="tab === 'stats'" />
        </el-tab-pane>
        <el-tab-pane label="运营号工具" name="ops" disabled>
          <el-alert type="info" :closable="false">P2 期启用</el-alert>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<style scoped>
.header {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid #e4e7ed;
}
.title { font-size: 18px; font-weight: 600; }
.right { display: flex; align-items: center; }
.muted { color: #666; font-size: 14px; }
.main { padding: 16px; background: #f5f5f7; }
</style>
